module.exports = __webpack_public_path__ + "static/media/folha2.d9a1e85d.png";